import React from 'react';
import styles from './TermsAndConditions.module.css';

const TermsAndConditions = () => {
  return (
    <div className={styles.termsContainer}>
      <div className={styles.termsHeader}>
        <h1>Terms and Conditions</h1>
        <p className={styles.lastUpdated}>Last updated: {new Date().toLocaleDateString()}</p>
      </div>

      <div className={styles.termsContent}>
        <section className={styles.section}>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using Spotfli ("the Platform"), you accept and agree to be bound by the terms and provision of this agreement. 
            If you do not agree to abide by these terms, please do not use this service.
          </p>
        </section>

        <section className={styles.section}>
          <h2>2. Description of Service</h2>
          <p>
            Spotfli is a digital platform that connects property seekers, property owners, hotel operators, and service providers in Cameroon. 
            Our services include but are not limited to:
          </p>
          <ul>
            <li>Property listings for rent and sale</li>
            <li>Hotel booking and reservation services</li>
            <li>Connection with home service providers</li>
            <li>Property management tools</li>
            <li>Payment processing services</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>3. User Accounts</h2>
          <h3>3.1 Registration</h3>
          <p>
            To access certain features of the Platform, you must register for an account. You agree to:
          </p>
          <ul>
            <li>Provide accurate, current, and complete information during registration</li>
            <li>Maintain and promptly update your account information</li>
            <li>Maintain the security of your password</li>
            <li>Accept responsibility for all activities that occur under your account</li>
            {/* <li>Be at least 18 years of age</li> */}
          </ul>

          <h3>3.2 Account Types</h3>
          <p>
            The Platform offers different account types including Property Seeker, Property Owner, Hotel Operator, and Service Provider. 
            Each account type has specific responsibilities and privileges.
          </p>
        </section>

        <section className={styles.section}>
          <h2>4. Property Listings</h2>
          <h3>4.1 Listing Requirements</h3>
          <p>
            Property owners and hotel operators agree to:
          </p>
          <ul>
            <li>Provide accurate and complete information about properties</li>
            <li>Include clear, recent photographs</li>
            <li>Disclose any material defects or issues</li>
            <li>Update availability status promptly</li>
            <li>Honor published prices and availability</li>
          </ul>

          <h3>4.2 Prohibited Listings</h3>
          <p>
            You may not list properties that:
          </p>
          <ul>
            <li>Are illegal, fraudulent, or misrepresented</li>
            <li>Violate any applicable laws or regulations</li>
            <li>Infringe on third-party rights</li>
            <li>Contain false or misleading information</li>
            <li>Are not actually available for rent or sale</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>5. Booking and Payment Terms</h2>
          <h3>5.1 Hotel Bookings</h3>
          <p>
            For hotel bookings, we utilize an escrow payment system:
          </p>
          <ul>
            <li>Payments are held securely until the hotel confirms the booking</li>
            <li>If the hotel declines the booking, full refunds are processed immediately</li>
            <li>Once confirmed, the one-night payment is released to the hotel</li>
            <li>Additional payment terms may apply for extended stays</li>
          </ul>

          <h3>5.2 Service Provider Bookings</h3>
          <p>
            Service bookings may require deposits or full payment in advance, depending on the service type and provider terms.
          </p>

          <h3>5.3 Payment Methods</h3>
          <p>
            We accept various payment methods including mobile money, bank transfers, and credit/debit cards as available in Cameroon.
          </p>
        </section>

        <section className={styles.section}>
          <h2>6. User Responsibilities</h2>
          <h3>6.1 Property Seekers/Tenants</h3>
          <p>
            You agree to:
          </p>
          <ul>
            <li>Provide accurate information in rental applications</li>
            <li>Respect property viewings and appointments</li>
            <li>Communicate professionally with property owners</li>
            <li>Honor booking commitments and cancellation policies</li>
          </ul>

          <h3>6.2 Property Owners/Hotel Operators</h3>
          <p>
            You agree to:
          </p>
          <ul>
            <li>Respond to inquiries in a timely manner</li>
            <li>Honor confirmed bookings and reservations</li>
            <li>Maintain properties in good condition</li>
            <li>Comply with all applicable housing and hospitality regulations</li>
          </ul>

          <h3>6.3 Service Providers</h3>
          <p>
            You agree to:
          </p>
          <ul>
            <li>Provide qualified and professional services</li>
            <li>Arrive on time for scheduled appointments</li>
            <li>Use appropriate materials and equipment</li>
            <li>Maintain necessary licenses and insurance</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>7. Cancellation and Refund Policy</h2>
          <h3>7.1 Hotel Bookings</h3>
          <p>
            Cancellation policies vary by hotel. Please review individual hotel policies before booking. 
            Generally, refunds are available if cancellations are made within the specified timeframe.
          </p>

          <h3>7.2 Service Bookings</h3>
          <p>
            Service providers set their own cancellation policies. Cancellation terms will be displayed before booking confirmation.
          </p>

          <h3>7.3 Property Rentals</h3>
          <p>
            Rental cancellation policies are determined by individual property owners and will be specified in the rental agreement.
          </p>
        </section>

        <section className={styles.section}>
          <h2>8. Privacy and Data Protection</h2>
          <p>
            We are committed to protecting your privacy. Our Privacy Policy explains how we collect, use, and protect your personal information. 
            By using the Platform, you consent to such processing and you warrant that all data provided by you is accurate.
          </p>
          <p>
            We comply with applicable data protection laws in Cameroon and implement appropriate security measures to protect user data.
          </p>
        </section>

        <section className={styles.section}>
          <h2>9. Intellectual Property</h2>
          <p>
            The Platform and its original content, features, and functionality are owned by MiraEdge.Tech and are protected by international 
            copyright, trademark, patent, trade secret, and other intellectual property laws.
          </p>
          <p>
            You may not reproduce, distribute, modify, create derivative works of, publicly display, or exploit any content from the Platform 
            without our express written permission.
          </p>
        </section>

        <section className={styles.section}>
          <h2>10. Prohibited Activities</h2>
          <p>
            You may not use the Platform to:
          </p>
          <ul>
            <li>Violate any laws or regulations</li>
            <li>Infringe upon the rights of others</li>
            <li>Post false, inaccurate, or misleading information</li>
            <li>Distribute spam or unsolicited commercial communications</li>
            <li>Spread viruses or malicious code</li>
            <li>Collect information about users without their consent</li>
            <li>Interfere with the proper working of the Platform</li>
            <li>Circumvent any security measures</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>11. Dispute Resolution</h2>
          <h3>11.1 Between Users</h3>
          <p>
            In case of disputes between users, we encourage direct communication and amicable resolution. 
            Spotfli may provide mediation services at our discretion.
          </p>

          <h3>11.2 Legal Jurisdiction</h3>
          <p>
            These terms shall be governed by and construed in accordance with the laws of the Republic of Cameroon. 
            Any disputes shall be subject to the exclusive jurisdiction of the courts of Cameroon.
          </p>
        </section>

        <section className={styles.section}>
          <h2>12. Limitation of Liability</h2>
          <p>
            Spotfli acts as a platform to connect users and does not guarantee the quality, safety, or legality of listings, 
            the truth or accuracy of users' content, or the ability of parties to complete transactions. 
            We are not liable for any damages resulting from:
          </p>
          <ul>
            <li>User interactions and transactions</li>
            <li>Inaccurate property information</li>
            <li>Service provider performance</li>
            <li>Booking cancellations or modifications</li>
            <li>Technical issues or platform unavailability</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>13. Modifications to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. We will notify users of significant changes through the Platform or via email. 
            Continued use of the Platform after changes constitutes acceptance of the modified terms.
          </p>
        </section>

        <section className={styles.section}>
          <h2>14. Termination</h2>
          <p>
            We may suspend or terminate your account and access to the Platform at our sole discretion, without notice, for conduct that we believe:
          </p>
          <ul>
            <li>Violates these terms</li>
            <li>Is harmful to other users</li>
            <li>Could create liability for Spotfli</li>
            <li>Is contrary to the interests of the Platform</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>15. Contact Information</h2>
          <p>
            For questions about these Terms and Conditions, please contact us at:
          </p>
          <div className={styles.contactInfo}>
            <p><strong>Email:</strong> legal@spotfli.com</p>
            <p><strong>Address:</strong> MiraEdge.Tech, Yaoundé, Cameroon</p>
            <p><strong>Phone:</strong> +237 XXX XXX XXX</p>
          </div>
        </section>

        <section className={styles.section}>
          <h2>16. Entire Agreement</h2>
          <p>
            These Terms and Conditions constitute the entire agreement between you and Spotfli regarding the use of the Platform 
            and supersede all prior agreements and understandings.
          </p>
        </section>

        <div className={styles.acknowledgment}>
          <p>
            By using Spotfli, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;